export default __webpack_public_path__ + "static/media/connect.a692aa76.webp";